export const SOURCE_KEY = 'sourceid';
export const SOURCE_PREFIX = 'qlwebsite_';
export const LEARNING_CENTER_SOURCE_PREFIX = 'qlwebsite_learn'
export const SOURCE_ID_DESTINATIONS = [
    'refinance.quickenloans.com',
    'refinance.qa.quickenloans.com',
    'mortgage.quickenloans.com',
    'accounts.quickenloans.com/signup',
    'mortgagelhp.quickenloans.com',
    'loans.quickenloans.com'
]
